import React, { useEffect } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

export const LandingPage = () => {
    const { signIn, user, authError } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (user) navigate('/home/dashboard');
    }, [user, navigate]);

    return (
        <div className="flex min-h-screen flex-col bg-neutral-50">
            <main className="flex flex-1 items-center justify-center px-4 py-12">
                <div className="w-full max-w-sm">
                    <div className="rounded-xl border border-neutral-200 bg-white shadow-sm">
                        {/* The oxblood rule is the brand's whole appearance here. */}
                        <div className="h-1 rounded-t-xl bg-brand-700" />

                        <div className="px-8 py-9">
                            <img
                                src={process.env.PUBLIC_URL + '/church-logo.png'}
                                alt="Bethel Christian Church"
                                className="h-9 w-auto"
                            />

                            <h1 className="mt-7 font-display text-2xl font-semibold tracking-tight text-neutral-900">
                                Event Forms
                            </h1>
                            <p className="mt-1.5 text-sm leading-relaxed text-neutral-500">
                                Request an on-campus event, track its approvals, and keep everyone who has to set it up
                                in the loop.
                            </p>

                            {authError && (
                                <p className="mt-6 rounded-md bg-red-50 px-3 py-2.5 text-sm text-red-800 ring-1 ring-inset ring-red-200">
                                    {authError}
                                </p>
                            )}

                            <div className="mt-7">
                                <GoogleLogin
                                    onSuccess={(response) => signIn(response)}
                                    onError={() => console.error('Google sign-in failed')}
                                    useOneTap
                                    theme="outline"
                                    size="large"
                                    width="320"
                                    text="continue_with"
                                />
                            </div>

                            <p className="mt-6 border-t border-neutral-100 pt-5 text-xs leading-relaxed text-neutral-400">
                                Sign in with your Bethel Google account. This system is for Bethel Christian School and
                                Church staff.
                            </p>
                        </div>
                    </div>
                </div>
            </main>

            <footer className="px-4 py-6">
                <p className="text-center text-xs text-neutral-400">
                    © {new Date().getFullYear()} Timothy Roe Computer Services, LLC
                </p>
            </footer>
        </div>
    );
};
